import { ReactComponent as InformationAltIconSVG } from '@/assets/icons/InformationAltIcon.svg';
import { SVGProps } from 'react';

const InformationAltIcon = (props: SVGProps<SVGSVGElement>) => <InformationAltIconSVG {...props} />;

export default InformationAltIcon;
